module.exports = __webpack_public_path__ + "img/touXiang2.67ffab51.png";